import request from '@/utils/request'

export function loadGoods (params) {
    return request({
        url: '/points/goods/pageMall',
        params: params,
        method: 'get'
    })
}
// 公司列表
export function loadCompany (params) {
    return request({
        url: '/points/goods/queryPointsGoodsForCompany',
        data: params,
        method: 'post'
    })
}
// 轮播图
export function slideshowList (params) {
    return request({
        url: '/pointPage/point-page/list',
        params: params,
        method: 'get'
    })
}

export function loadCompanyGoods (params) {
    return request({
        url: '/points/goods/pageMall',
        data: params,
        method: 'post'
    })
}
export function loadGoodsDetail (id) {
    return request({
        url: `/points/goods/queryPointsGoodsDetail/${id}`,
        method: 'get'
    })
}
export function loadGoodsAvailablePoints (params) {
    return request({
        url: `/points/sys/user/point/queryUserPointsForSupplier`,
        data: params,
        method: 'post'
    })
}
export function insertCart (params) {
    return request({
        url: `/points/goods/shopping-cart/insert`,
        params: params,
        method: 'post'
    })
}
export function loadCart () {
    return request({
        url: `/points/goods/shopping-cart/query`,
        method: 'get'
    })
}
export function delCartGoods (ids) {
    return request({
        url: `/points/goods/shopping-cart/delete`,
        data: ids,
        method: 'post'
    })
}
export function updateCartGoods (params) {
    return request({
        url: `/points/goods/shopping-cart/update`,
        params: params,
        method: 'post'
    })
}
export function createOrder (data) {
    return request({
        url: `/points/order/create`,
        data: data,
        method: 'post'
    })
}
export function supplierInfo () {
    return request({
        url: `/points/goodsScope/supplierInfo`,
        method: 'get'
    })
}
